import { navLinks } from '@/mocks/homeData';

const colA = ['图文速递', '视频切片', '热度榜', '打包合集'];
const colB = ['栏目分区', '话题墙', '帮助说明', '内容索引'];

export default function Footer() {
  return (
    <footer className="bg-foreground-100 border-t border-foreground-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-8">
          <div className="col-span-2 md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">
                五一<span className="text-primary-600">黑料</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              聚合全网热门五一黑料汇总，从图文到视频一网打尽。每日手动整理打包资源，省去东翻西找的麻烦，想看的内容一次看个够。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-refresh-line"></i> 内容每日手动更新 · 收录以来源为准
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-bold text-foreground-950">栏目速览</h4>
            <ul className="mt-4 space-y-2.5">
              {colA.map((t, i) => (
                <li key={i}>
                  <a href="#top" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <h4 className="text-sm font-bold text-foreground-950">站内导航</h4>
            <ul className="mt-4 space-y-2.5">
              {colB.map((t, i) => (
                <li key={i}>
                  <a href="#top" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <h4 className="text-sm font-bold text-foreground-950">直达瓜田</h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {navLinks.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  className="rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  {n.label}
                </a>
              ))}
            </div>
            <a
              href="#packs"
              className="mt-4 inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-download-2-line"></i> 去打包合集
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-foreground-200 bg-foreground-50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">© 2026 五一黑料 · 本站为资讯聚合演示站，内容以来源为准，转载需注明出处。</p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#top" className="hover:text-primary-600">关于本站</a>
            <a href="#top" className="hover:text-primary-600">免责声明</a>
            <a href="#top" className="hover:text-primary-600">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}